// @flow

import React from 'react';
import PropTypes from "prop-types";
import T from './T';

import {getDecimalSep} from "../trans";

const propTypes = {
	id: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    /**
     * Väärtuse andmetüüp:
     * string - string
     * number - number (teisendatakse väärtus reaalarvuks ja tagasi)
     * integer - täisarv (teisendatakse väärtus täisarvuks ja tagasi)
     */
    valueType: PropTypes.string,
    valueDecimals: PropTypes.string,
    value: PropTypes.any
};

const defaultProps = {
	valueType: 'string',
	value: null
};


class Tvalue extends T {
	
	constructor(props) {
		super(props);
		this.state = {
			value: this.valueToString(props.value),
			isValid: this.isValid(props.value)
		};
	}
	
	componentWillReceiveProps(newProps) {
		this.setState({
			value: this.valueToString(newProps.value),
			isValid: this.isValid(newProps.value)
		});
	}
	
	isValid(value) {
		if (value == null || value === '') return true;
		value = value.toString();
		value = value.trim();
		let result: number;
		switch (this.props.valueType) {
			case 'number':
				value = value.replace(',','.').replace(' ','');
				result = Number.parseFloat(value);
				return !Number.isNaN(result);

			case 'integer':
				result = Number.parseInt(value);
				return !Number.isNaN(result);

			default:
				return true;
		}
	}
	
	valueToString(value) {
		if (value == null || Number.isNaN(value)) return '';
		switch (this.props.valueType) {
			case 'number':
				value = this.round(value, this.props.valueDecimals);
				if (value === undefined || value === null) return '';
				let converted = value.toString();
				let sep = getDecimalSep();
				if (sep === '.') return converted;
				return converted.replace('.', ',');
			case 'integer':
				if (Number.isNaN(value)) {
					return '';
				}
			// eslint-disable-next-line no-fallthrough
			default:
				return value.toString();
		}
	}
	
	round(value, decimals) {
		if( decimals === undefined || decimals === null || decimals === '') decimals = 0;
		return Math.round(value*Math.pow(10, decimals)) / Math.pow(10, decimals);
		// return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
	}
	
	valueFromString(value) {
		if (value == null) return null;
		value = value.trim();
		switch (this.props.valueType) {
			case 'number':
				if (value === '') return null;
				value = value.replace(',','.').replace(' ','');
				let r1 = Number.parseFloat(value);
				if (Number.isNaN(r1)) return null;
				return r1;
			case 'integer':
				if (value === '') return null;
				let r2 = Number.parseInt(value);
				if (Number.isNaN(r2)) return null;
				return r2;
			default:
				return value;
		}
	}
	
	render() {
		let style = {};
		if (this.props.style) style = {...this.props.style};
		if (this.props.width) {
			if (!style.float) style.float = 'left';
			style.width = this.props.width;
		}
		let classname = '';
		if (this.props.className) classname += ' ' + this.props.className;
		if (!this.state.isValid) classname += ' invalid';
		return (<span id={this.props.id} className={classname} style={style}>{this.state.value == null ? "" : this.state.value}</span>);
	}
}

Tvalue.propTypes = propTypes;
Tvalue.defaultProps = defaultProps;

export default Tvalue;
